var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.statusColor,"dark":_vm.statusDark,"small":"","label":""}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.statusIcon))]),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }